import React, { useEffect, useState } from "react";

// import "antd/dist/antd.css";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import "rsuite/dist/rsuite.min.css";

import { InputGroup } from "react-bootstrap";
import CurrencyFormat from "react-currency-format";
import { Box } from "@chakra-ui/react";
import { poNumberFormate } from "jsFunctions/helperFunctions";
import { FaTrash } from "react-icons/fa";
import DrawerButton from "../component/buttons/drawerButton";


const CreditApplicable = ({ maxAllowedCredit,getData, autoCount,creditError,allCreditData,creditItem,deleteCredit,isEdit,isDisabled,editData,isCreditValid,currency}) => {
 
  const [useAmount, setUseAmount] = useState("")
  const [addTogglePaymentIdx, setAddTogglePaymentIdx] = useState(true);
  const [currentItem,setCurrentItem] = useState({})
  const [remaningCredit, setRemainingCredit] = useState(0)
  const [creditValidationError, setCreditValidationError] = useState("");

  const onChangeValues = (amount) => {
    const data = {
      ...creditItem,
      usAmt:amount
    };
    getData(data);
  };

  useEffect(()=>{
    if(creditItem?.crId){
      setCurrentItem(creditItem?.crId)
      setUseAmount(creditItem?.usAmt);
      const remainingAmount = parseFloat(creditItem?.crId?.amt) - ((parseFloat(creditItem?.crId?.usAmt || 0) + parseFloat(creditItem?.crId?.resAmt || 0)));
      const existCreditData = editData?.crApl?.list;
      const existCreditItem = existCreditData?.find((item)=>item?.crId?._id === creditItem?.crId?._id)
      const totalAvailableCredit = parseFloat(remainingAmount || 0) + parseFloat(existCreditItem?.usAmt || 0)
      setRemainingCredit(parseFloat(totalAvailableCredit) - parseFloat(creditItem?.usAmt || 0))

    }
    else{
      setCurrentItem(creditItem)
      const useCr = allCreditData?.find((item)=>item?._id === creditItem?._id)
      if(creditItem?.usAmt){
        setUseAmount(creditItem?.usAmt);
      }
      const remainingAmount = creditItem?.amt - (parseFloat(useCr?.usAmt) + parseFloat(creditItem?.resAmt));
      const totalAvailableCredit = parseFloat(remainingAmount || 0) 
      setRemainingCredit(parseFloat(totalAvailableCredit) - parseFloat(creditItem?.usAmt || 0))
    }

  },[creditItem])

  return (
    <div className={`${addTogglePaymentIdx ? "show" : "hide"}`}
>
      <div className="payment-list_array mt-3">
        <div className="d-flex">
          <span className="payment-details">{poNumberFormate(currentItem?.crNo)}</span>
        </div>
        <div
          className="d-flex toggleImage-content"
        >
          <DrawerButton
            isOpen={addTogglePaymentIdx}
            handleClick={() => {
              setAddTogglePaymentIdx(!addTogglePaymentIdx);
            }}
          />
        </div>
              {!creditItem?.crId ?
              <div className="d-flex"
                onClick={() => deleteCredit(currentItem?._id,'')}
              >
                 <span className="mt">
                   <FaTrash
                     style={{
                       fontSize: "16px",
                       color: "red",
                       cursor: "pointer",
                     }}
                   />
                 </span>
             </div>
             :
             <div className="d-flex"
             onClick={() => deleteCredit(currentItem?._id,creditItem?.crId)}
           >
              <span className="mt">
                <FaTrash
                  style={{
                    fontSize: "16px",
                    color: "red",
                    cursor: "pointer",
                  }}
                />
              </span>
          </div>
              }
            
        
      </div>
       
      <div
 className={`payment-inner_box ${
  addTogglePaymentIdx ? "show-content" : "hide-content"
}`}      >
        <Row>
          <Col>
          <Box display="flex" className="input-box">
            <Form.Label>Cr No <span className="span-star">*</span></Form.Label>
            <Form.Control
                        type="text"
                        name="coNo"
                        placeholder="No"
                        value={poNumberFormate(currentItem?.crNo)}
                        disabled
                      />

            </Box>

          </Col>
          <Col>
          <Box display="flex" className="input-box">
            <Form.Label>Total Credit <span className="span-star">*</span></Form.Label>
            <InputGroup>
            <InputGroup.Text><span className="rupee-symbol">{currency?.symbol || "₹" }</span> </InputGroup.Text>
                <CurrencyFormat
                  customInput={Form.Control}
                  type="text"
                  value={currentItem?.amt || ""}
                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  disabled
                />
            
            </InputGroup>
            </Box>

          </Col>
        </Row>
        <Row>
          
          <Col>
          <Box display="flex" className="input-box">
            <Form.Label>Remaning Credit <span className="span-star">*</span></Form.Label>
            <InputGroup>
            <InputGroup.Text><span className="rupee-symbol">{currency?.symbol || "₹" }</span> </InputGroup.Text>
                <CurrencyFormat
                  customInput={Form.Control}
                  type="text"
                  value={remaningCredit || 0}
                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  disabled
                  isInvalid={remaningCredit < 0}
                />
            
            </InputGroup>
            </Box>

          </Col>
          <Col>
          <Box display="flex" className="input-box">
            <Form.Label>Use Credit <span className="span-star">*</span></Form.Label>
            <InputGroup>
            <InputGroup.Text><span className="rupee-symbol">{currency?.symbol || "₹" }</span> </InputGroup.Text>
                <CurrencyFormat
                  customInput={Form.Control}
                  type="text"
                  value={useAmount || ""}
                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  onValueChange={(e) => {
                    const value = parseFloat(e.value || 0);
                    const availableCredit = parseFloat(remaningCredit || 0) + parseFloat(useAmount || 0);

                    setUseAmount(e.value);

                    if (value < 0) {
                      setCreditValidationError('Use Credit should be greater than zero');

                      isCreditValid(false);
                      return;
                    }

                    if (value > maxAllowedCredit) {
                      setCreditValidationError(`Use Credit cannot exceed payable amount (${maxAllowedCredit.toFixed(2)})`);

                      isCreditValid(false);
                      return;
                    }

                    if (value > availableCredit) {
                      setCreditValidationError(`Use Credit cannot exceed available credit (${availableCredit.toFixed(2)})`);

                      isCreditValid(false);
                      return;
                    }

                    setCreditValidationError("");
                    isCreditValid(true);

                    onChangeValues(e.value);
                  }}
                  disabled={isDisabled}
                />
            
            </InputGroup>
            </Box>
            <p className="form_error">{creditValidationError || creditError[`credit.${autoCount}.useAmount`]}</p>

          </Col>
        </Row>
       
       
      </div>
     
    </div>
  );
};

export default CreditApplicable;
